import { createAction, props } from '@ngrx/store';
import { Candidate } from '../models/candidate.model';

export const setCandidate = createAction('[Candidates Component] SetCandidate', props<Candidate>());
